import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Button, TablePagination } from "@mui/material";
import { useDebounce, useQueryParams } from "../../../hooks";
import { getUser } from "./Helper";

const UnverifiedUser = () => {
  const context = useOutletContext();
  const [user, setUser] = useState([]);
  const { getParam, setMultiParam } = useQueryParams();
  const currentPage = getParam("page");
  const currentLimit = getParam("pageSize");
  const [userPage, setUserPage] = useState(parseInt(currentPage) || 0);
  const [userLimit, setUserLimit] = useState(parseInt(currentLimit) || 10);
  const [userTotal, setUserTotal] = useState(0);
  const [search, setSearch] = useState("");
  const debounceSearch = useDebounce(search, 500)
  console.log("search", search);
  const handleChangePage = (event, newPage) => {
    fetchData(newPage, userLimit);
    setUserPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setUserLimit(parseInt(event.target.value, 10));
    setUserPage(0);
    fetchData(0, parseInt(event.target.value, 10));
  };

  const fetchData = (page, limit) => {
    getUser(page, limit, debounceSearch)
      .then((data) => {
        setUser(data.data.clients.rows);
        setUserTotal(data.data.clients.totalItems);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    context(["Pending Approvals", "Unverified Users"]);
    getUser(userPage, userLimit, debounceSearch)
      .then((data) => {
        console.log(data.data.clients.rows);
        setUser(data.data.clients.rows);
        setUserTotal(data.data.clients.totalItems);
      })
      .catch((err) => console.log(err));
  }, [debounceSearch]);

  useEffect(() => {
    setMultiParam({
      page: userPage,
      pageSize: userLimit
    })
  }, [userPage, userLimit])


  return (
    <div className="p-5 shadow-md bg-white">
      <div className="grid grid-cols-6 gap-2">
        <h3
          className="col-span-5 text-lg uppercase tracking-wider font-bold"
          style={{ color: "#2EBAA3" }}
        >
          Unverified Users
        </h3>
        <input
          onChange={(e) => setSearch(e.target.value)}
          type="text"
          id="search"
          placeholder="Search"
          class="px-3 py-1.5 mr-2 mb-2 form-control block w-full text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none"
        />
      </div>
      <br />
      <div class="overflow-x-auto relative">
        <table class="w-full text-sm text-left text-gray-500">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" class="py-3 px-6 uppercase">
                Sr.
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Name
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Company Name
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Email
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Source
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Phone
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Created At
              </th>
            </tr>
          </thead>
          <tbody>
            {user?.map((jb, index) => {
              return (
                <tr class="bg-white border-b ">
                  <th
                    scope="row"
                    class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap cursor-pointer"
                    // onClick={(e) => viewCustomer(e, customer._id)}
                    key={index}
                  >
                    {index + 1}
                  </th>
                  <td className="py-4 px-6 flex items-center gap-2">
                    <span>{jb?.name}</span>
                    {jb?.registered && (
                      <svg
                        className="w-5 h-5 text-blue-500"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.707a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414L9 13.414l4.707-4.707z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </td>

                  <td class="py-4 px-6">{jb?.company}</td>
                  <td class="py-4 px-6">{jb?.email}</td>
                  <td className="py-4 px-6 max-w-[250px] overflow-hidden text-ellipsis whitespace-nowrap">
                    {(() => {
                      const parts = [
                        jb?.utm_source,
                        jb?.utm_medium,
                        jb?.utm_campaign,
                        jb?.term,
                      ].filter(part => part?.trim());

                      return parts.length > 0 ? parts.join(' | ') : <span className="italic text-gray-400 text-center tect-lg">-</span>;
                    })()}
                  </td>
                  <td class="py-4 px-6">{jb?.countryCode
                    ? `${jb.countryCode.startsWith('+') ? '' : '+'}${jb.countryCode} ${jb?.phone || ''}`
                    : jb?.phone || ''}</td>
                  <td className="py-4 px-6">
                    {jb?.createdAt == null
                      ? "-"
                      : jb?.createdAt.split("T")[0]}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <TablePagination
        component="div"
        count={userTotal}
        page={userPage}
        onPageChange={handleChangePage}
        rowsPerPage={userLimit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[2, 5, 10, 25, 50, 100]}
      />
    </div>
  );
};

export default UnverifiedUser;
